import { BrandColors } from '../../constants';
import { makeStyles } from 'tss-react/mui';

export const IFrameStyles = makeStyles()(() => ({
  container: {
    background: 'none',
    overflow: 'hidden',
    '& #root > header, #root > footer, #root > .icp-recordal-footer, #root > .skipToMainContent': {
      margin: 0,
      padding: 0,
      display: 'none',
    },
    '& #root > .main-content': {
      margin: 0,
      padding: 0,
    },
    '& iframe': {
      minHeight: '100vh',
      width: '100%',
      border: 'none',
      overflowY: 'auto',
      overflowX: 'hidden',
      backgroundColor: BrandColors.white,
    },
  },
}));
